<app-floorplan-product-menu
  [title]="tooltipTextTelemetry"
  [hasConfigurations]="telemetries.length > 0"
  [visible]="floorplan.floorplanState.telemetriesVisible"
  [locked]="floorplan.floorplanState.telemetriesLocked"
  [itemTextVisible]="floorplan.floorplanState.telemetriesItemTextVisible"
  (visibilityUpdate)="floorplan.floorplanState.telemetriesVisible = $event"
  (lockUpdate)="floorplan.floorplanState.telemetriesLocked = $event"
  (itemTextVisibilityUpdate)="updateTelemetriesItemTextVisibility($event)"
  (addPlaceholderToFloorplan)="addPlaceholder()"
  (dragPlaceholder)="dragPlaceholder()"
  configPath="telemetry"
>
  @for (telemetry of telemetries; track telemetry) {
    <div>
      <hr />
      <app-configured-product
        [productConfiguration]="telemetry"
        [imageUrl]="getImageUrl(telemetry)"
        [fallbackImageUrl]="fallbackImageUrl"
        [numberOfFloorplanItems]="floorplan.countPlacedTelemetries(telemetry)"
        [attachments]="[]"
        (add)="addTelemetry(telemetry)"
        (delete)="deleteTelemetry(telemetry)"
        (dragStart)="drag(telemetry)"
        editPath="telemetry"
      >
      </app-configured-product>
    </div>
  }
</app-floorplan-product-menu>
